import HttpRequest from '@/api/axios';
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL2);
export default {
    stepsInfo(params) {
        return axios.request({
            url: "user-steps/info",
            method: "get",
            params
        });
    },
    stepsCheckin(data) {
        return axios.request({
            url: "activity-sub/steps-checkin",
            method: "post",
            data
        });
    },
    groupstepsCheckin(data) {
        return axios.request({
            url: "activity-sub/group-steps-checkin",
            method: "post",
            data
        });
    }
}
